import { Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'wpro-sample-component-laboratory',
  template: `
    <form [formGroup]="colorFormGroup" (submit)="submit()">
      <div class="fdx-o-grid__row fdx-o-grid__row--guttered-small fdx-u-mb--6">
        <div class="fdx-o-grid__item--12">
          <div class="fdx-c-form-group fdx-c-form-group--select fdx-c-form-group--asd">
          <span class="fdx-c-form-group__item">
            <select [formControl]="colorControl" class="fdx-c-form-group__select" id="modalPriority">
              <option value="red" selected>Red</option>
              <option value="orange">Orange</option>
              <option value="yellow">Yellow</option>
              <option value="green">Green</option>
              <option value="blue">Blue</option>
              <option value="indigo">Indigo</option>
              <option value="violet">Violet</option>
            </select>
            <span aria-hidden="true" class="fdx-c-form-group__icon">
              <ciam-icon class="fdx-c-icon" aria-hidden="true" key="chevron"></ciam-icon>
            </span>
            <label class="fdx-c-form-group__label " for="modalPriority">Color</label>
          </span>
          </div>
        </div>
      </div>

      <div class="fdx-u-align--center">
        <button class="fdx-c-button fdx-c-button--full-width fdx-c-button--primary fdx-c-button--responsive">
          Submit
        </button>
      </div>
    </form>
  `,
  standalone: false
})
export class SampleComponent {
  @Output()
  color = new EventEmitter<string>();

  readonly colorControl = new UntypedFormControl('red');
  readonly colorFormGroup = new UntypedFormGroup({
    color: this.colorControl
  });

  submit(): void {
    this.color.emit(this.colorControl.value);
  }
}
